export default "__VITE_ASSET__DbHfBZik__"